import {Component, OnInit} from '@angular/core';
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";

@Component({
    selector: 'ns-black-list-page',
    templateUrl: './ns-black-list.page.html',
    standalone: false
})
export class NsBlackListPage extends PageComponent implements OnInit {

  objectBrowserRequest: any;
  subObjectBrowserRequest: any;

  defaultLabel: string = "Notification Black List";


  ngOnInit(): void {

    super.ngOnInit();

    // Main Structure
    this.objectBrowserRequest = {

      "extractDto": false,
      "createMode": true,

      'entries' : [
        {
          'id'                : 1,
          'objectAlias'       : 'ns.NsRecipientBlackList',
          'level'             : 1,
          'parentBinding'     : 'none',
          'dummyParentCreate' : true,
          'dummyParentLabel'  : "Black List",
          'newEntryNodeCreate': true,
          'newEntryNodeLabel' : "Anlegen"
        },
      ]
    };


  }
}
